// Footer.jsx
import React from "react";
import "../Styles/Footer.css";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/";
  const currentYear = new Date().getFullYear();

  // Animation variants
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.25,
      },
    },
  };

  // handle navigation and highlight
  const handleNavigate = (path, section) => {
    navigate(path, { state: { highlight: section } });
  };

  return (
    <motion.footer
      className={`footer ${!isHome ? "footer-white" : ""}`}
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <div className="footer-container">
        <motion.div className="footer-about" variants={fadeUp}>
          <h2>T-RIDES</h2>
          <p>
            Experience luxury rides designed for comfort, style, <br />
            and unforgettable journeys. Wherever you go, we ensure <br />
            excellence every mile of the way.
          </p>
          <p className="call-center">
            Call Center: <span>(234) 703 0792 420</span>
          </p>
        </motion.div>

        <div className="footer-links">
          <motion.div className="link-column" variants={fadeUp}>
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a onClick={() => navigate("/vehicle-fleet")}>Book a Ride</a>
              </li>
              <li>
                <a onClick={() => handleNavigate("/about-us", "faq")}>Faq</a>
              </li>
              <li>
                <a onClick={() => handleNavigate("/", "services")}>Car Varieties</a>
              </li>
              <li>
                <a onClick={() => handleNavigate("/contact-us", "contact")}>Contact</a>
              </li>
            </ul>
          </motion.div>

          <motion.div className="link-column" variants={fadeUp}>
            <h4>Our Services</h4>
            <ul>
              <li>Corporate travels</li>
              <li>Special events</li>
              <li>Airport transport</li>
              <li>Wedding limousine</li>
            </ul>
          </motion.div>
        </div>
      </div>

      <motion.div className="footer-bottom" variants={fadeUp}>
        <p>© {currentYear} T-Rides Executive, All Rights Reserved</p>
      </motion.div>
    </motion.footer>
  );
};

export default Footer;
